/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataStructureTreeIcon16Regular = forwardRef('DataStructureTreeIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 2a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4.75v2.25H7V7a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-.25H4.75V12c0 .138.112.25.25.25h2V12a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-.25H5A1.75 1.75 0 0 1 3.25 12V5H2a1 1 0 0 1-1-1V2Zm1.5.5v1h6v-1h-6Zm11 6h-5v-1h5v1Zm-5 5v-1h5v1h-5Z" })));
});
